import {
  fetchLoiTemplates,
  createLoiTemplate,
  deleteLoiTemplate,
} from './asyncThunk';

const loiTemplatesReducers = {
  [fetchLoiTemplates.pending]: (state) => {
    state.status = 'loading';
    state.loading = true;
    state.error = null;
  },
  [fetchLoiTemplates.fulfilled]: (state, { payload }) => {
    state.status = 'succeeded';
    state.loading = false;
    state.loiTemplates = payload?.data || payload || [];
  },
  [fetchLoiTemplates.rejected]: (state, action) => {
    state.status = 'error';
    state.loading = false;
    state.loiTemplates = [];
    state.error = action.error?.message || 'Failed to fetch LOI templates';
  },

  [createLoiTemplate.pending]: (state) => {
    state.status = 'creating';
    state.error = null;
  },
  [createLoiTemplate.fulfilled]: (state, { payload }) => {
    state.status = 'succeeded';
    if (payload?.success) {
      state.loiTemplates.push(payload.data || payload);
    }
  },
  [createLoiTemplate.rejected]: (state, action) => {
    state.status = 'error';
    state.error = action.error?.message || 'Failed to create LOI template';
  },

  [deleteLoiTemplate.pending]: (state) => {
    state.status = 'deleting';
    state.error = null;
  },
  [deleteLoiTemplate.fulfilled]: (state, action) => {
    state.status = 'succeeded';
    if (action.payload?.success) {
      const deletedId = action.meta.arg.did;
      state.loiTemplates = state.loiTemplates.filter(
        (t) => String(t.id) !== String(deletedId),
      );
    }
  },
  [deleteLoiTemplate.rejected]: (state, action) => {
    state.status = 'error';
    state.error = action.error?.message || 'Failed to delete LOI template';
  },
};

export default loiTemplatesReducers;

export { fetchLoiTemplates, createLoiTemplate, deleteLoiTemplate };
